import React from 'react';
import PropTypes from 'prop-types';

import * as common from 'libs/commonFunc';
import { SplitPaneTemplate } from 'components';
import { CtExamSummary, CtExamList, CtExamTag, CtExamLeakPC, CtExamLeakFile, CtExamDetail } from 'containers';

import styles from './ExamLayout.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

// 비활성화 계정 체크
const ExamLayout = ({ currentPath, beforePath, isDetailView }) => {
  return (
    <div className={cx('examLayout-wrapper')}>
      <div className={cx('list-area')}>
        <CtExamSummary currentPath={currentPath} beforePath={beforePath} />
      </div>
      <div className={cx('content-area', { 'hide-Detail': !isDetailView })}>
        <SplitPaneTemplate
          listData={
            (currentPath === '/main/exam/infectionpc' && (
              <CtExamLeakPC currentPath={currentPath} beforePath={beforePath} />
            )) ||
            (currentPath === '/main/exam/leakfile' && (
              <CtExamLeakFile currentPath={currentPath} beforePath={beforePath} />
            )) ||
            (currentPath.indexOf('/main/exam') !== -1 && (
              <CtExamList currentPath={currentPath} beforePath={beforePath} />
            ))
          }
          detail={<CtExamDetail currentPath={currentPath} beforePath={beforePath} />}
        />
      </div>
    </div>
  );
};

export default ExamLayout;



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamLayout.js